// extracted by mini-css-extract-plugin
export default {"mainContainer":"GridSlide_mainContainer__zUZ1T"};